export function download(blob: string, filename?: string): void {
  const a = document.createElement('a');
  a.href = blob;
  a.download = filename ?? `${new Date().toISOString().slice(0, 19).replace('T', '_')}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
